'use client';

import Icon from '@mdi/react';
import { motion } from 'framer-motion';

interface ChipProps {
    className?: string;
    icon?: string;
    layoutId?: string;
    isCompact?: boolean;
    children: React.ReactNode;
}

const Chip = ({
    className = '',
    icon,
    layoutId,
    isCompact = false,
    children,
}: ChipProps) => {
    const bgClass = className.includes('bg-') ? '' : 'bg-slate-100';

    return (
        <motion.li
            layoutId={layoutId}
            className={`flex items-center gap-1 ${bgClass} ${
                isCompact ? 'px-2 first:pl-3 last:pr-3' : 'rounded-full px-3'
            } select-none py-1 font-bold ${className}`}
        >
            {icon && <Icon path={icon} size={0.8} className="-ml-1" />}
            {children}
        </motion.li>
    );
};

interface ChipsProps {
    className?: string;
    layoutId?: string;
    isCompact?: boolean;
    children: React.ReactNode;
}

export const Chips = ({
    className = '',
    layoutId,
    isCompact = false,
    children,
}: ChipsProps) => {
    return (
        <motion.ul
            layoutId={layoutId}
            className={`flex self-start ${
                isCompact ? 'gap-0 overflow-hidden rounded-full' : 'gap-2'
            } ${className}`}
        >
            {children}
        </motion.ul>
    );
};

export default Chip;
